import { useNavigate } from "react-router-dom";
import { aboutHeroData } from "@/mocks/aboutData";

export default function HeroSection() {
  const navigate = useNavigate();

  const handleClick = (href: string) => {
    if (href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(href);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-[50svh] md:min-h-[50svh] flex items-center overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={aboutHeroData.image}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/65 via-foreground-950/40 to-foreground-950/70" />
        <div className="absolute top-[-6%] right-[-5%] w-[40vw] h-[40vw] rounded-full bg-primary-500/6 blur-[80px] pointer-events-none" />
        <div className="absolute bottom-[-5%] left-[-8%] w-[35vw] h-[35vw] rounded-full bg-accent-500/5 blur-[70px] pointer-events-none" />
      </div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-4 md:px-8 pt-14 md:pt-20 pb-10 md:pb-14">
        <nav className="mb-5 md:mb-6" aria-label="パンくず">
          <ol className="flex items-center flex-wrap gap-1 text-xs md:text-sm">
            {aboutHeroData.breadcrumbs.map((crumb, idx) => (
              <li key={idx} className="flex items-center gap-1">
                {crumb.href ? (
                  <a
                    href={crumb.href}
                    onClick={(e) => { e.preventDefault(); handleClick(crumb.href); }}
                    className="text-background-100/60 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {crumb.label}
                  </a>
                ) : (
                  <span className="text-background-100/90">
                    {crumb.label}
                  </span>
                )}
                {idx < aboutHeroData.breadcrumbs.length - 1 && (
                  <span className="text-background-100/40" aria-hidden="true">＞</span>
                )}
              </li>
            ))}
          </ol>
        </nav>

        <div className="max-w-3xl">
          <span className="inline-block text-[10px] md:text-xs font-bold tracking-[0.12em] uppercase text-primary-300 px-2.5 py-1 rounded-full border border-primary-300/30 font-label mb-4 md:mb-5">
            {aboutHeroData.label}
          </span>

          <h1 className="font-heading text-[1.7rem] sm:text-3xl md:text-[2.5rem] lg:text-[2.75rem] font-bold text-background-50 leading-[1.55] tracking-tight mb-4 md:mb-5">
            {aboutHeroData.mainCopy.split("\n").map((line, i) => (
              <span key={i} className={`inline md:block ${i === 0 ? "md:mb-1.5" : ""}`}>
                {line}
              </span>
            ))}
          </h1>

          <p className="text-sm md:text-base text-background-100/85 leading-relaxed max-w-xl mb-6 md:mb-7">
            {aboutHeroData.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            {aboutHeroData.ctas.map((cta) => (
              <button
                key={cta.label}
                onClick={() => handleClick(cta.href)}
                className={`inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm md:text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  cta.primary
                    ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                    : "border border-background-100/50 text-background-50 hover:bg-background-50/10"
                }`}
              >
                {cta.label}
                <i className={`ri-${cta.primary ? "arrow-right" : "arrow-down"}-line`} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}